import { render, staticRenderFns } from "./InventoryReservationForm.vue?vue&type=template&id=212643ad"
import script from "./InventoryReservationForm.vue?vue&type=script&lang=js"
export * from "./InventoryReservationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports